module.exports = __webpack_public_path__ + "static/media/template.793ae987.png";